import { createContext, useContext, useState, useEffect, useRef } from 'react'
import { useLocation } from 'react-router-dom'

import COLORS from '../COLORS.json'

const ColorContext = createContext()

export function ColorProvider({ children }) {
	const location = useLocation()
	const [colors, setColorsState] = useState([])
	const [isLoading, setIsLoading] = useState(false)
	const intervalIdRef = useRef(null)
	const cooldownQueue = useRef([])
	// const [isAutoRotate, setIsAutoRotate] = useState(true)

	const paletteKeys = Object.keys(COLORS)

	function getNextPaletteKey() {
		const used = cooldownQueue.current
		const available = paletteKeys.filter(k => !used.includes(k))

		if (available.length === 0) {
			used.splice(0, used.length - 1)
			return getNextPaletteKey()
		}

		const randomIndex = Math.floor(Math.random() * available.length)
		const selectedKey = available[randomIndex]
		used.push(selectedKey)

		if (used.length > 8) used.shift()

		return selectedKey
	}

	function startRotation() {
		const first = getNextPaletteKey()
		setColorsState(COLORS[first])

		const id = setInterval(() => {
			const key = getNextPaletteKey()
			setColorsState(COLORS[key])
		}, 7000)

		intervalIdRef.current = id
		// setIsAutoRotate(true)
	}

	function stopRotation() {
		if (intervalIdRef.current) {
			clearInterval(intervalIdRef.current)
			intervalIdRef.current = null
		}
		// setIsAutoRotate(false)
	}

	useEffect(() => {
		// Якщо це root сторінка — запускаємо обертання
		if (location.pathname === '/') {
			startRotation()
			return stopRotation
		}
		// Інакше — чекаємо зовнішнє setColors
	}, [])

	// Це публічна функція, яка зупиняє обертання та встановлює нові кольори
	const setColors = newColors => {
		stopRotation()
		setColorsState(newColors)
	}

	const resetToDefault = () => {
		stopRotation()
		startRotation()
	}

	return (
		<ColorContext.Provider
			value={{
				colors,
				setColors,
				isLoading,
				setIsLoading,
				resetToDefault,
				// isAutoRotate,
			}}
		>
			{children}
		</ColorContext.Provider>
	)
}

export function useColorContext() {
	return useContext(ColorContext)
}
